import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useRef, useState } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Header from "../../components/Header/NewHeader";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import { cap } from "../../utils/utils";
import Pagination from "../../components/Pagination";
import DialogTitle from "@material-ui/core/DialogTitle";
import SideMenu from "../../components/SideMenu/SideMenu";
import { getNotif, readNotif, readNotifAll } from "../../store/middleware";
import { getNotifLength } from "../../store/middleware/generic.middleware";
import { endLoading, initLoading } from "../../store/slices/generics.slice";
import classIcon from "../../assets/images/icons/icon_notifications_header.svg";
import noNotifications from "../../assets/images/placeholder/notifications_empty.png";

const nl2br = (text) =>
  text?.split("\n").map((line, index) => (
    <span key={index}>
      {line}
      <br />
    </span>
  ));

function Notifications() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { notif, paginationNotif } = useSelector((state) => state.genericReducer);

  const [notification, setNotification] = useState(null);
  const [filters, setFilter] = useState({ pageNumber: 1, pageSize: 10 });
  const iframeRef = useRef(null);

  const handleIframeLoad = () => {
    const iframeDocument = iframeRef.current?.contentWindow?.document;
    if (iframeDocument?.body) {
      iframeRef.current.style.height = `${iframeDocument.body.scrollHeight}px`;
    }
  };

  const notifications = notif
    ? notif.map(({ id, createdAt, read, notificationSent: { module, subject, message } }) => ({
        id,
        createdAt,
        read,
        module,
        subject,
        message,
      }))
    : [];

  const pagination = (page) => {
    filters["pageNumber"] = Number(page);
    applyFilters(filters);
  };

  const applyFilters = async (filters) => {
    setFilter(filters);
    await dispatch(initLoading());
    await dispatch(getNotif(user.id, filters.pageNumber, filters.pageSize));
    await dispatch(getNotifLength(user?.id));
    await dispatch(endLoading());
  };

  const resetFilter = async () => {
    applyFilters({ pageNumber: 1, pageSize: 10 });
  };

  const handleSetReadedAll = async () => {
    const body = { read: true };

    await dispatch(readNotifAll(body));
    resetFilter();
  };

  const handleSetReaded = (id) => {
    const body = { id: id, read: true };

    dispatch(readNotif(body));

    resetFilter();
    setNotification(null);
  };

  useEffect(() => {
    applyFilters(filters);
    // eslint-disable-next-line
  }, [notification]);

  return (
    <div className="view new-view notifications-view">
      <SideMenu />
      <section>
        <Header
          icon={classIcon}
          rightIcon={true}
          title={t("NOTIFICATIONS")}
          onClickRightIcon={() => handleSetReadedAll()}
        />
        <div className="new-container">
          <div className="content">
            {user?.role === "student" && (
              <Link to="/manage-account/notification">
                <p className="settingsLink">{t("NOTIFICATION_SETTINGS")}</p>
              </Link>
            )}

            {notifications.length > 0 ? (
              notifications.map(({ id, read, subject, createdAt, message, module }) => (
                <div key={id} className="new-box new-box-table-list new-box-notification">
                  <div className={`notificationInfo${!read ? " unReadNotification" : ""}`}>
                    <h4>{module}</h4>
                    <p>{subject}</p>
                    <p className="fromNow">{cap(moment(createdAt).locale(t("LOCALE")).fromNow())}</p>
                  </div>
                  <button
                    className="view-button"
                    onClick={() => setNotification({ id, read, subject, createdAt, message })}
                  >
                    {t("VIEW")} <i className="fa fa-angle-right" aria-hidden="true" />
                  </button>
                </div>
              ))
            ) : (
              <Fragment>
                <p className="placeholderText">{t("NO_NOTIFICATIONS")}</p>
                <img className="placeholderImage" src={noNotifications} />
              </Fragment>
            )}
          </div>
          <Pagination
            totalFound={paginationNotif?.pageSize}
            totalPages={paginationNotif?.totalPages}
            pageCurrent={paginationNotif?.pageNumber}
            totalResults={paginationNotif?.totalFound}
            onClick={(page, type) => pagination(page, type)}
          />

          <Dialog
            keepMounted
            open={!!notification}
            id="dialog-notification"
            className="dialog-notification"
            onClose={() => handleSetReaded(notification?.id)}
          >
            <DialogTitle id="dialog-notification-title">
              {notification?.subject ? notification?.subject : "Subject"}
            </DialogTitle>
            <DialogContent>
              <div id="dialog-notification-message">
                {notification?.message?.includes("<!doctype html>") ? (
                  <iframe
                    ref={iframeRef}
                    onLoad={handleIframeLoad}
                    title="notification-message"
                    srcDoc={notification?.message}
                    className="dialog-notification-iframe"
                  />
                ) : (
                  nl2br(notification?.message)
                )}
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => handleSetReaded(notification?.id)}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </section>
    </div>
  );
}

export default Notifications;
